import { AppointmentRequestTime } from 'apps/wrapper/src/services/appointment/types/appointment-request-time';
import { FC } from 'react';
import { useRequestDetailsView } from '../../../../hooks/use-request-details-view';
import { LabeledSection } from '../../../../shared/labeled-section/labeled-section';
import { RequestDateItem } from './request-date-item/request-date-item';
import { RequestDateSectionSkeleton } from './request-date-section.skeleton';
import { RequestDatesList } from './request-date-section.styles';

export const RequestDateSection: FC = () => {
  const { requestDetails } = useRequestDetailsView();

  if (!requestDetails) return <RequestDateSectionSkeleton />;

  if (requestDetails.appointmentRequestTimes && requestDetails.appointmentRequestTimes.length > 0) {
    return (
      <LabeledSection label={requestDetails.isDirectlyBooked ? 'Date & Time' : 'Request Date & Time'}>
        <RequestDatesList>
          {requestDetails.appointmentRequestTimes.map((time: AppointmentRequestTime) => (
            <RequestDateItem
              key={time.dateStart.toString()}
              requestTime={time}
              isDirectlyBooked={requestDetails.isDirectlyBooked}
            />
          ))}
        </RequestDatesList>
      </LabeledSection>
    );
  }

  return null;
};
